/**
 * Service: userApi
 */
angular.module('acme.common.service.userApi', [
  'acme.common.factory.apiVersion'
])
.service('UserApiService', [ '$http', 'ApiVersionFactory', function ($http, ApiVersionFactory) {

  return {

    init: function (endpoint) {
      this.service = endpoint + '/users';
      this.roles.service = endpoint + '/rbac/users';
      this.groups.service = endpoint + '/rbac/users';
      this.permissions.service = endpoint + '/rbac/permissions/users';
      return this;
    },

    service: '',

    /**
     * Logs a user in
     * @param {{ email: string; password: string }} props
     * @returns {Promise}
     */
    login: function (props) {

      var headers = {};

      if (props.header) {
        if (props.header.name && props.header.value) {
          headers[props.header.name] = props.header.value;
        }
      }

      return $http({
        method: 'put',
        url: this.service,
        data: props,
        headers: headers
      });

    },

    /**
     * Logs a user out
     *
     * @returns {*}
     */
    logout: function() {
      return $http({
        method: 'get',
        url: this.service + '/logout'
      });
    },

    /**
     * Send email confirmation request
     *
     * Accepts:
     * {
       *   token: {String}
       * }
     *
     * @param props
     * @returns {*}
     */
    confirm: function (props) {
      return $http({
        method: 'get',
        url: this.service + '/confirm',
        headers: {
          "x-acme-token": props.token
        }
      });
    },

    /**
     * Recover password
     *
     * @param email
     * @returns {*}
     */
    recover: function (email) {
      return $http({
        method: 'get',
        url: this.service + '/recoverPassword',
        headers: {
          "x-acme-email": email
        }
      });
    },


    /**
     * Allow admins to reset passwords for email-less users
     * @param {{ password: string }} props
     * @returns {*}
     */
    adminReset: function(props) {
      return $http({
        method: 'put',
        url: this.service + '/'+ props.id + '/password',
        data: {
          password: props.password
        }
      });
    },

    /**
     * Completes recovery step
     *
     * @param {{ password: string; token: string }} props
     */
    changePassword: function (props) {
      return $http({
        method: 'put',
        url: this.service + '/finishRecoverPassword',
        data: props
      });
    },
    
    /**
     * @param {{ email: string; oldPassword: string; password: string }} props
     */
    resetExpiredPassword: function (props) {
      return $http({
        method: 'put',
        url: this.service + '/resetPassword',
        data: props
      });
    },

    /**
     * Creates a new user
     * @param {{
     *  userName: string;
     *  password: string;
     *  firstName: string;
     *  lastName: string;
     *  title: string;
     *  email: string;
     *  phoneNumber: string;
     *  tenantId: number;
     * }} props
     * @returns {Promise}
     */
    create: function (props) {

      return $http({
        method: 'post',
        url: this.service,
        data: {
          userName: props.userName,
          password: props.password,
          firstName: props.firstName,
          lastName: props.lastName,
          email: props.email,
          title: props.title,
          phoneNumber: props.phoneNumber,
          tenantId: props.tenantId
        }
      });

    },

    /**
     * Gets a user
     *
     * @param userId {Integer}
     * @returns {*}
     */
    view: function (userId) {

      return $http({
        method: 'get',
        url: this.service + '/' + userId
      });

    },

    /**
     * Updates user profile information
     * @param {{
     *  active: boolean
     *  userId: number
     *  password: string
     *  firstName: string
     *  lastName: string
     *  departmentId: number
     *  roles: Array
     * }} props
     * @returns {Promise}
     */
    update: function (props) {
      var av = new ApiVersionFactory();

      return $http({
        method: 'put',
        url: av.init({ url: this.service + '/' + props.id, version: 'v2' }),
        data: {
          active: props.active,
          password: props.password,
          oldPassword: props.oldPassword,
          userName: props.userName,
          firstName: props.firstName,
          lastName: props.lastName,
          streetAddress1: props.streetAddress1,
          streetAddress2: props.streetAddress2,
          country: props.country,
          state: props.state,
          city: props.city,
          zipCode: props.zipCode,
          email: props.email,
          title: props.title,
          departmentId: props.departmentId,
          profileImage: props.profileImage,
          roles: props.roles,
          phoneNumber: props.phoneNumber,
          startDayOfWeek: props.startDayOfWeek,
          hourFormat: props.hourFormat,
          dateFormat: props.dateFormat,
          /**
           * Always true, we're deprecating the non-accessible grid 
           * @link https://peeksters.atlassian.net/browse/APP-4348
           */
          accessibilityEnabled: true,
        }
      });
    },

    /**
     * Removes a user
     * @param {number} userId
     * @returns {Promise}
     */
    remove: function (userId) {
      return $http({
        method: 'delete',
        url: this.service + '/' + userId
      });
    },

    roles: {
      service: '',

      list: function(id) {
        return $http({
          method: 'get',
          url: this.service + '/' + id + '/roles'
        });
      }
    },

    groups: {
      service: '',

      list: function(id) {
        return $http({
          method: 'get',
          url: this.service + '/' + id + '/groups'
        });
      },

      remove: function(id, type) {
        return $http({
          method: 'delete',
          url: this.service + '/' + id + '/' + type
        });
      }
    },

    permissions: {
      service: '',

      list: function(id) {
        return $http({
          method: 'get',
          url: this.service + '/' + id
        });
      }
    }

  };

}]);